"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var DropDown_1 = __importDefault(require("../../common/DropDown/DropDown"));
var localStorage_1 = __importDefault(require("../../config/localStorage"));
var icons_1 = __importDefault(require("../../theme/icons"));
var react_i18next_1 = require("react-i18next");
var service_1 = require("../../translation/service");
function LanguageSelector(_a) {
    var _this = this;
    var country = _a.country;
    // props: InferProps<typeof LanguageSelector.propTypes>,
    var client = (0, client_1.useApolloClient)();
    var _b = (0, react_1.useState)([]), languages = _b[0], setLanguages = _b[1], _c = (0, react_1.useState)(''), language = _c[0], setLanguage = _c[1], _d = (0, react_i18next_1.useTranslation)(), i18n = _d.i18n, t = _d.t;
    (0, react_1.useEffect)(function () {
        if (country) {
            init();
        }
    }, [country]);
    function handleChange(value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLanguage(value);
                        return [4 /*yield*/, localStorage_1.default.setItem('language', value)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, i18n.changeLanguage(value)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    var setDefaultlanguage = function () { return __awaiter(_this, void 0, void 0, function () {
        var storeLang;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.getItem('language')];
                case 1:
                    storeLang = _a.sent();
                    return [4 /*yield*/, i18n.changeLanguage(storeLang !== null && storeLang !== void 0 ? storeLang : 'en')];
                case 2:
                    _a.sent();
                    setLanguage(storeLang !== null && storeLang !== void 0 ? storeLang : 'en');
                    return [2 /*return*/];
            }
        });
    }); };
    var init = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var tmp, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tmp = [];
                    return [4 /*yield*/, service_1.TranslaitonService.getLanguages(client, country)];
                case 1:
                    data = (_a.sent()).data;
                    data.map(function (l) {
                        var code = l.code, id = l.id, name = l.name;
                        tmp.push({
                            id: id,
                            label: (0, lodash_1.capitalize)(name),
                            value: code === null || code === void 0 ? void 0 : code.toLowerCase(),
                        });
                    });
                    return [4 /*yield*/, localStorage_1.default.setItem('languages', tmp)];
                case 2:
                    _a.sent();
                    setLanguages(tmp);
                    setDefaultlanguage();
                    return [2 /*return*/];
            }
        });
    }); }, [i18n, t, country]);
    return (react_1.default.createElement(DropDown_1.default, { defaultValue: language, icon: react_1.default.createElement(icons_1.default, { className: 'icon_orange', height: 32, name: 'language', width: 32 }), placeholder: 'Select Language', name: 'language', onChange: function (e) {
            handleChange(e.value);
        }, options: languages, value: language }));
}
LanguageSelector.propTypes = {
    error: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    style: prop_types_1.default.object,
    className: prop_types_1.default.string,
    country: prop_types_1.default.string,
};
exports.default = LanguageSelector;
